import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { LayoutGrid, Users, Calendar, FileText, MoreHorizontal } from "lucide-react";

const TABS = [
  { to: "/", icon: LayoutGrid, label: "Dashboard", testId: "tab-home", end: true },
  { to: "/customers", icon: Users, label: "Customers", testId: "tab-customers" },
  { to: "/meetings", icon: Calendar, label: "Meetings", testId: "tab-meetings" },
  { to: "/quotes", icon: FileText, label: "Quotes", testId: "tab-quotes" },
  { to: "/more", icon: MoreHorizontal, label: "More", testId: "tab-more" },
];

// Routes that are nested under "More" — keep "More" active for these too
const MORE_ROUTES = ["/more", "/share-links", "/team", "/sheets", "/blocked-slots", "/initial-docs"];

export default function BottomNav() {
  const location = useLocation();
  const moreActive = MORE_ROUTES.some((r) => location.pathname.startsWith(r));

  return (
    <nav className="sg-bottombar" data-testid="bottom-nav">
      <div className="sg-tabs">
        {TABS.map((t) => {
          const Icon = t.icon;
          // Special-case "More" to highlight on nested routes
          if (t.to === "/more") {
            return (
              <NavLink
                key={t.to}
                to={t.to}
                data-testid={t.testId}
                className={`sg-tab ${moreActive ? "sg-tab-active" : ""}`}
              >
                <Icon size={20} />
                <span>{t.label}</span>
              </NavLink>
            );
          }
          return (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={t.testId}
              className={({ isActive }) => `sg-tab ${isActive ? "sg-tab-active" : ""}`}
            >
              <Icon size={20} />
              <span>{t.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
